{
  "common": {
    "lastUpdated": "最后更新：{{date}}"
  },
  "privacy": {
    "title": "隐私声明",
    "updated": "2026年8月7日",
    "intro": "本声明说明<strong>{{tradingName}}</strong>（&ldquo;我们&rdquo;）如何收集和使用个人数据。我们是下述个人数据的<strong>数据控制者</strong>，即由我们决定为何以及如何处理这些数据。",
    "dataCollected": {
      "heading": "我们收集的数据及原因",
      "items": [
        "<strong>家长账户数据</strong>（姓名、电子邮件、电话号码、国家、时区）&mdash; 用于创建和管理您的账户、提供课程并与您联系。法律依据：履行我们与您的合同。",
        "<strong>孩子资料数据</strong>（名字、年龄或年级、学习水平和目标）&mdash; 用于将您的孩子安排到合适的班级并个性化教学。法律依据：履行合同，并经您作为家长或监护人的同意。",
        "<strong>学习内容</strong>（作业录音、练习册、导师反馈、进度笔记）&mdash; 用于教学、评估和报告进度。法律依据：履行合同。",
        "<strong>支持消息与测评咨询</strong> &mdash; 用于回答问题并安排课程。法律依据：履行合同以及我们回复咨询的合法利益。",
        "<strong>使用、设备和日志数据</strong>（IP地址、设备与浏览器标识、浏览页面、登录事件）&mdash; 用于安全、防欺诈、故障排查及改进服务。法律依据：合法利益。",
        "<strong>营销偏好</strong> &mdash; 用于发送您要求的更新信息。法律依据：同意，您可随时撤回。"
      ],
      "noChildData": "我们不会故意直接从儿童处收集数据；账户由家长或监护人创建和管理。"
    },
    "shareWith": {
      "heading": "我们与谁共享数据",
      "items": [
        "<strong>服务提供商／次级处理者</strong> &mdash; 按照我们指示行事的托管、数据库、视频课程、邮件发送和分析服务提供商。",
        "<strong>Stripe</strong>，我们的支付处理商，用于结账、订阅管理、付款、税费计算和开票。",
        "<strong>专业顾问</strong> &mdash; 必要时的法律和会计顾问。",
        "<strong>监管机构</strong> &mdash; 依法要求或为保护我们的权利。"
      ],
      "noSell": "我们不会出售个人数据。"
    },
    "transfers": {
      "heading": "国际数据传输",
      "body": "我们的服务提供商可能在您所在国家/地区以外（包括英国/欧洲经济区以外）处理数据。在这种情况下，我们依赖适当的保障措施，如充分性认定或标准合同条款。"
    },
    "retention": {
      "heading": "数据保留",
      "body": "只要您的账户处于活跃状态，我们会保留账户和学习数据，之后最长再保留24个月，以便您在返回时仍可查看进度报告。因法律、税务或会计原因必须保留的记录，将按法律规定的期限保存。此后数据将被删除或匿名化处理。"
    },
    "rights": {
      "heading": "您的权利",
      "body": "根据适用法律，您可以要求访问您的数据、更正、删除、限制处理、数据可携带，并对基于合法利益的处理提出异议。您可以随时撤回同意。请通过<0>联系我们</0>给我们留言，我们将在一个月内回复。如果您位于英国或欧洲经济区，您还有权向当地监管机构投诉。"
    },
    "security": {
      "heading": "安全性",
      "body": "我们采取适当的技术和组织措施，包括传输加密、访问控制、行级数据库安全以及作业上传的私有存储，确保只有您和您孩子的指定教师才能访问已提交的作业。"
    },
    "cookies": {
      "heading": "Cookie",
      "body": "我们使用必要的 Cookie 和本地存储来保持您的登录状态并保障服务安全。我们可能使用有限的分析 Cookie 以了解网站的使用情况。您可以在浏览器设置中管理或屏蔽 Cookie；屏蔽必要 Cookie 将导致无法登录。"
    },
    "contact": {
      "heading": "联系方式",
      "body": "隐私相关问题：<0>联系我们</0>。"
    }
  },
  "terms": {
    "title": "条款与条件",
    "updated": "2026年8月7日",
    "intro": "本条款与条件规范您对 {{tradingName}} 网站以及我们面向4至12岁儿童的在线英语实时授课服务（&ldquo;服务&rdquo;）的使用。该服务由<strong>{{legalName}}</strong>{{tradingSuffix}}（&ldquo;我们&rdquo;）提供。创建账户、预约测评或购买套餐即表示您与我们达成协议。",
    "tradingSuffix": "（以 {{tradingName}} 名义经营）",
    "sections": {
      "acceptance": {
        "heading": "1. 接受条款",
        "body": "访问或继续使用本服务即表示您同意本条款。如果您代表某机构购买，您确认自己有权代表该机构；如果您以个人身份购买，您确认自己已达到法定年龄，并且是所注册儿童的家长或法定监护人。"
      },
      "service": {
        "heading": "2. 服务内容",
        "body": "我们提供实时、按计划安排的在线英语课程，以小班或一对一形式授课，并配有学习材料、作业点评和进度报告。课程时间、班级组成和教师可能会不时变化。在保持整体服务水平的前提下，我们可能会在不另行通知的情况下更新或改进课程内容。"
      },
      "accounts": {
        "heading": "3. 账户与信息准确性",
        "items": [
          "您必须提供准确的账户及孩子信息，并保持其为最新状态。",
          "您有责任对登录凭证保密，并对您账户下的所有活动（包括孩子对账户的使用）负责。",
          "账户仅限单个家庭使用，不得共享或转售。"
        ]
      },
      "acceptableUse": {
        "heading": "4. 可接受使用规范",
        "intro": "您不得滥用本服务。具体而言，您不得：",
        "items": [
          "将服务用于任何非法目的，或违反任何适用法规；",
          "在课程中从事欺诈、垃圾信息、骚扰、辱骂或扰乱行为；",
          "侵犯我们或第三方的知识产权，包括录制、复制、再分发或转售课程内容或材料；",
          "干扰服务的安全性或完整性，包括引入恶意软件、探测或扫描系统，或抓取网站内容。"
        ]
      },
      "licence": {
        "heading": "5. 许可与限制",
        "body": "我们授予您有限的、非独占的、不可转让的权利，以访问服务及您所选套餐所包含的材料，仅供个人非商业性的家庭使用。您不得对服务进行逆向工程、转售、再许可，或规避服务的任何技术限制。"
      },
      "ip": {
        "heading": "6. 知识产权",
        "body": "我们保留对服务及其知识产权的全部所有权，包括课程体系、练习册、录音、软件、品牌和文档。您孩子提交的作品（如作业录音和练习册）仍归您所有；您授予我们有限许可，以便我们仅为向您提供和改进服务而托管和处理这些内容。"
      },
      "serviceLevel": {
        "heading": "7. 服务水平",
        "body": "我们致力于可靠地提供课程，但不保证服务不中断、及时、安全或无差错。在法律允许的最大范围内，我们不承担包括适销性和特定用途适用性在内的所有默示保证。学习成果取决于多种因素，无法予以保证。"
      },
      "payments": {
        "heading": "8. 付款、账单与订阅",
        "body1": "除非结账时另有说明，套餐费用按月以美元预付，并自动续订直至取消。您可随时通过家长门户或账单门户取消订阅；访问权限将持续至您已付费期限结束。",
        "body2": "付款通过我们的支付服务商 Stripe 安全处理。我们是所有订单的记录卖家，并对服务、账单查询和退款负责。卡片信息由 Stripe 处理，绝不会存储在我们的系统中。适用税费将在结账时计算并显示。有关退款方式，请参阅我们的<0>退款政策</0>。"
      },
      "suspension": {
        "heading": "9. 暂停与终止",
        "body": "在出现严重违反本条款、未付款、存在安全或欺诈风险，或反复／严重违反政策的情况下，我们可能暂停或终止访问权限。在可行的情况下，我们会先通知您并给予您解决问题的机会。终止后您的访问权限将结束；您可在30天内申请导出孩子已提交的作业，之后这些内容可能被删除。"
      },
      "liability": {
        "heading": "10. 责任限制",
        "body": "在法律允许的最大范围内，我们因服务而产生或与之相关的累计责任，以您在索赔前12个月内支付的费用为限。我们不承担间接、后果性或特殊损害赔偿责任，包括利润、数据或商誉的损失。本条款不限制因欺诈、死亡或因过失造成的人身伤害所产生的责任，或任何依法不可排除的其他责任。"
      },
      "indemnity": {
        "heading": "11. 赔偿",
        "body": "您同意就您或您孩子提交的内容、非法使用服务或违反本条款所引发的索赔向我们提供赔偿。"
      },
      "changes": {
        "heading": "12. 条款变更",
        "body": "我们可能会更新本条款；届时将在此发布修订版本并更新上方日期。变更生效后继续使用即视为接受该变更。"
      },
      "general": {
        "heading": "13. 一般条款",
        "body": "未经我们同意，您不得转让您的权利；我们可能因合并或收购而转让我们的权利。任何一方均不对超出其合理控制范围的事件造成的延误负责。本条款受卖方所在司法管辖区法律管辖，该司法管辖区法院对争议拥有专属管辖权。"
      },
      "contact": {
        "heading": "14. 联系方式",
        "body": "有关本条款、账单或订单的问题：<0>联系我们</0>。"
      }
    }
  },
  "refund": {
    "title": "退款政策",
    "updated": "2026年8月7日",
    "intro": "我们希望每个家庭都能对孩子的学习充满信心。<strong>{{legalName}}</strong> 为月度套餐提供<strong>{{refundDays}}天无理由退款保证</strong>。",
    "window": {
      "heading": "退款期限",
      "body": "如果您对购买不满意，可以在订单日期后 {{refundDays}} 天内申请全额退款。此政策同样适用于改变主意或服务问题的情况。"
    },
    "howTo": {
      "heading": "如何申请退款",
      "items": [
        "通过<0>联系我们</0>给我们留言，注明您结账时使用的电子邮箱地址，并告知我们套餐及订单日期。",
        "您也可以随时通过家长门户中的账单门户管理或取消您的套餐。"
      ]
    },
    "cancelling": {
      "heading": "取消您的套餐",
      "body": "您可以随时通过家长门户或账单门户取消订阅。取消将停止未来的自动续订；您的孩子在您已付费期限结束前仍可访问课程和资料。"
    },
    "renewals": {
      "heading": "续订费用",
      "body": "如果续订扣款出乎意料，请在扣款后 {{refundDays}} 天内联系我们，我们将进行审核并在适当情况下予以退款。"
    },
    "processing": {
      "heading": "处理时间",
      "body": "已批准的退款将退回原支付方式。根据您的银行或发卡机构，资金通常在5至10个工作日内到账。"
    }
  }
}
